

var imageWithTextOverlayV2Fn = function (section) {

    var valueIncreaseTime = 1000;
    var valueIncreaseInterval = 10;

    var increaseNum = function (targetDom, targetValue, stepLength) {
        var currentValue = parseInt(targetDom.text());
        var intervalId = setInterval(function () {
            currentValue += stepLength;
            if (currentValue >= targetValue) {
                currentValue = targetValue;
                clearInterval(intervalId);
            }
            targetDom.text(currentValue);
        }, valueIncreaseInterval);
    }
    
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    var bgImg = section.find('.image-with-text-overlay-v2-bg img');
    var valueDoms = section.find('.product-performance-value-number');

    setTimeout(function () {
        for(var i = 0; i < valueDoms.length; i++) {
            var valueDom = valueDoms.eq(i);
            valueDom.text('0');
            var targetValue = Number(valueDom.attr('pdvalue'));
            var stepLength = Math.ceil(targetValue / (valueIncreaseTime / valueIncreaseInterval));
            increaseNum(valueDom, targetValue, stepLength);
        }
    }, 1000);
};

var imageWithTextOverlayV2Init = function () {
    var imageWithTextOverlayV2 = $('.shopify-section--image-with-text-overlay-v2');
    for (var i = 0; i < imageWithTextOverlayV2.length; i++) {
        imageWithTextOverlayV2Fn(imageWithTextOverlayV2[i]);
    }
};

imageWithTextOverlayV2Init();

var x1SectionImgAnmiV2Fn = function (section) {
    section = $(section);

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'bottom bottom',
        scrub: true,
        animation: gsap.timeline()
            .fromTo(section.find('.x1-section-img-anmi-v2-bg-wrapper'), {
                width: '100vw'
            }, {
                width: '87.5vw'
            }, 0)
    });
};

var x1SectionImgAnmiV2Init = function () {
    var x1SectionImgAnmiV2 = $('.x1-section-img-anmi-v2');
    for (var i = 0; i < x1SectionImgAnmiV2.length; i++) {
        x1SectionImgAnmiV2Fn(x1SectionImgAnmiV2[i]);
    }
};

x1SectionImgAnmiV2Init();

var cardGroupV2Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.card-group-v2-block'), {
                y: '20%',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};

var cardGroupV2Init = function () {
    var cardGroupV2 = $('.shopify-section--card-group-v2');
    for (var i = 0; i < cardGroupV2.length; i++) {
        cardGroupV2Fn(cardGroupV2[i]);
    }
};

cardGroupV2Init();

var x1SectionImgAnmiV3Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .fromTo(section.find('.x1-section-img-anmi-v3-title'), {
                y: '-10vw',
                scale: 6
            }, {
                y: '-10vw',
                scale: 1
            }, 0)
            .fromTo(section.find('.x1-section-img-anmi-v3-subtitle, .x1-section-img-anmi-v3-tag'), {
                opacity: 0
            }, {
                opacity: 1
            })
            .to(section.find('.x1-section-img-anmi-v3-title'), {
                y: 0
            }, '<')
    });

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + clientHeight * 0.5 + ' top',
        pin: true,
        scrub: true,
        animation: gsap.timeline()
            .fromTo(section.find('.x1-section-img-anmi-v3-board'), {
                y: '0'
            }, {
                y: '-48vh'
            })
    });

    ScrollTrigger.create({
        trigger: section.find('.x1-section-img-anmi-v3-block-2')[0],
        start: 'top+=' + clientHeight * 0.5 + ' bottom',
        end: 'top+=' + clientHeight * 0.5 + ' center',
        scrub: true,
        animation: gsap.timeline()
            .fromTo(section.find('.x1-section-img-anmi-v3-card-wrapper'), {
                y: '0',
                opacity: 0
            }, {
                y: '-3vh',
                opacity: 1
            }, 0)
    });
};

var x1SectionImgAnmiV3Init = function () {
    var x1SectionImgAnmiV3 = $('.x1-section-img-anmi-v3');
    for (var i = 0; i < x1SectionImgAnmiV3.length; i++) {
        x1SectionImgAnmiV3Fn(x1SectionImgAnmiV3[i]);
    }
};

x1SectionImgAnmiV3Init();

var x1SectionImgAnmiV4Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: 'bottom center',
        scrub: true,
        animation: gsap.timeline()
            .to(section.find('.x1-section-img-anmi-v4-fg'), {
                y: '-15vh'
            }, 0)
    });
};

var x1SectionImgAnmiV4Init = function () {
    var x1SectionImgAnmiV4 = $('.x1-section-img-anmi-v4');
    for (var i = 0; i < x1SectionImgAnmiV4.length; i++) {
        x1SectionImgAnmiV4Fn(x1SectionImgAnmiV4[i]);
    }
};

x1SectionImgAnmiV4Init();

var cardGroupV3Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.card-group-v3-block'), {
                y: '20%',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};

var cardGroupV3Init = function () {
    var cardGroupV3 = $('.shopify-section--card-group-v3');
    for (var i = 0; i < cardGroupV3.length; i++) {
        cardGroupV3Fn(cardGroupV3[i]);
    }
};

cardGroupV3Init();

var x1SectionImgAnmiV5Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.bh-block1 .bh-title'), {
                x: '-68vw',
                scale: 6
            }, 0)
    });

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight * 2),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.bh-block2'), {
                y: '100vh'
            }, 0)
            .to (section.find('.bh-block2-content'), {
                opacity: 0,
                duration: 0.5
            }, 1)
            .from(section.find('.bh-block3'), {
                scale: 4,
                opacity: 0
            }, 1.5)
    });
};

var x1SectionImgAnmiV5Init = function () {
    var x1SectionImgAnmiV5 = $('.x1-section-img-anmi-v5');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        x1SectionImgAnmiV5Fn(x1SectionImgAnmiV5[i]);
    }
};

x1SectionImgAnmiV5Init();

var x1SectionImgAnmiV6Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight * 8),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.bh-block1 .bh-content-wrapper, .bh-block2 .bh-content-wrapper'), {
                opacity: 0,
                x: '-20%'
            })
            .from(section.find('.bh-block2'), {
                opacity: 0,
                zIndex: 0
            })
            .to(section.find('.bh-block1 .bh-content-wrapper, .bh-block2 .bh-content-wrapper'), {
                opacity: 0,
                x: '20%'
            })
            .from(section.find('.bh-block3'), {
                opacity: 0,
                zIndex: 0
            })
            .from(section.find('.bh-block3 .bh-content-wrapper, .bh-block4 .bh-content-wrapper'), {
                opacity: 0,
                x: '-20%'
            })
            .from(section.find('.bh-block4'), {
                opacity: 0,
                zIndex: 0
            })
            .to(section.find('.bh-block3 .bh-content-wrapper, .bh-block4 .bh-content-wrapper'), {
                opacity: 0,
                x: '20%'
            })
            .from(section.find('.bh-block5'), {
                opacity: 0,
                zIndex: 0
            })
            .from(section.find('.bh-block5 .bh-content-wrapper'), {
                opacity: 0,
                y: '-20%'
            })
    });
};

var x1SectionImgAnmiV6Init = function () {
    var x1SectionImgAnmiV6 = $('.x1-section-img-anmi-v6');
    for (var i = 0; i < x1SectionImgAnmiV6.length; i++) {
        x1SectionImgAnmiV6Fn(x1SectionImgAnmiV6[i]);
    }
};

x1SectionImgAnmiV6Init();

var cardGroupV4Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.to(section.find('.card-group-v4-bg1'), {
                height: '0',
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};

var cardGroupV4Init = function () {
    var cardGroupV4 = $('.shopify-section--card-group-v4');
    for (var i = 0; i < cardGroupV4.length; i++) {
        cardGroupV4Fn(cardGroupV4[i]);
    }
};

cardGroupV4Init();